import {
  GET_ALL_LICENSES_REQUEST,
  GET_ALL_LICENSES_SUCCESS,
  GET_ALL_LICENSES_FAIL,
  GET_LICENSE_BY_ID_REQUEST,
  GET_LICENSE_BY_ID_SUCCESS,
  GET_LICENSE_BY_ID_FAIL,
  GET_ALL_ACTIVE_LICENSES_REQUEST,
  GET_ALL_ACTIVE_LICENSES_SUCCESS,
  GET_ALL_ACTIVE_LICENSES_FAIL,
  ADD_LICENSE_REQUEST,
  ADD_LICENSE_SUCCESS,
  ADD_LICENSE_FAIL,
  UPDATE_LICENSE_STATUS_REQUEST,
  UPDATE_LICENSE_STATUS_SUCCESS,
  UPDATE_LICENSE_STATUS_FAIL
} from '../constants/LicenseConstants';

const initialState = {
  responseBody: null,
  loading: false,
  msg: null,
};

export const GetAllLicenses = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_LICENSES_REQUEST:
      return { ...state, loading: true, msg: null };

    case GET_ALL_LICENSES_SUCCESS:
      return { ...state, loading: false, responseBody: action.payload, msg: null };

    case GET_ALL_LICENSES_FAIL:
      return { ...state, loading: false, msg: action.payload, responseBody: null };

    default:
      return state;
  }
};

export const GetLicenseById = (state = initialState, action) => {
  switch (action.type) {
    case GET_LICENSE_BY_ID_REQUEST:
      return { ...state, loading: true, msg: null };

    case GET_LICENSE_BY_ID_SUCCESS:
      return { ...state, loading: false, responseBody: action.payload, msg: null };

    case GET_LICENSE_BY_ID_FAIL:
      return { ...state, loading: false, msg: action.payload, responseBody: null };

    default:
      return state;
  }
};

export const GetAllActiveLicenses = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_ACTIVE_LICENSES_REQUEST:
      return { ...state, loading: true, msg: null };

    case GET_ALL_ACTIVE_LICENSES_SUCCESS:
      return { ...state, loading: false, responseBody: action.payload, msg: null };

    case GET_ALL_ACTIVE_LICENSES_FAIL:
      return { ...state, loading: false, msg: action.payload, responseBody: null };

    default:
      return state;
  }
};

export const AddLicense = (state = initialState, action) => {
  switch (action.type) {
    case ADD_LICENSE_REQUEST:
      return { ...state, loading: true, msg: null };

    case ADD_LICENSE_SUCCESS:
      return { ...state, loading: false, responseBody: action.payload, msg: null };

    case ADD_LICENSE_FAIL:
      return { ...state, loading: false, msg: action.payload, responseBody: null };

    default:
      return state;
  }
};

export const UpdateLicenseStatus = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_LICENSE_STATUS_REQUEST:
      return { ...state, loading: true, msg: null };

    case UPDATE_LICENSE_STATUS_SUCCESS:
      return { ...state, loading: false, responseBody: action.payload, msg: null };

    case UPDATE_LICENSE_STATUS_FAIL:
      return { ...state, loading: false, msg: action.payload, responseBody: null };

    default:
      return state;
  }
};

// ================= SELECTOR FUNCTIONS =================
export const selectAllLicensesData = (state) => state.alllicenses?.responseBody;
export const selectAllLicensesLoading = (state) => state.alllicenses?.loading;
export const selectAllLicensesError = (state) => state.alllicenses?.msg;

export const selectAddLicenseData = (state) => state.addlicense?.responseBody;
export const selectAddLicenseLoading = (state) => state.addlicense?.loading;
export const selectAddLicenseError = (state) => state.addlicense?.msg;

export const selectAllActiveLicensesData = (state) => state.allactivelicenses?.responseBody;
export const selectAllActiveLicensesLoading = (state) => state.allactivelicenses?.loading;
export const selectAllActiveLicensesError = (state) => state.allactivelicenses?.msg;

export const selectUpdateLicenseStatusData = (state) => state.updatelicensestatus?.responseBody;
export const selectUpdateLicenseStatusLoading = (state) => state.updatelicensestatus?.loading;
export const selectUpdateLicenseStatusError = (state) => state.updatelicensestatus?.msg;

export const selectLicenseByIdData = (state) => state.licensebyid?.responseBody;
export const selectLicenseByIdLoading = (state) => state.licensebyid?.loading;
export const selectLicenseByIdError = (state) => state.licensebyid?.msg;